// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__25ECs","resendInfoText":"OnGoingPaymentBox_resendInfoText__3vsG-"};